import { Box, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza/text/Typography/Typography'

type FileUploadOverlayProps = {
    title?: string
}

export const FileUploadOverlay = ({ title = 'Dokumente hochladen' }: FileUploadOverlayProps) => {
    return (
        <FixedOverlay>
            <Typography variant="headline1" color={tokens.ColorTextInverse}>
                {title}
            </Typography>
        </FixedOverlay>
    )
}

const FixedOverlay = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#08124a80',
    zIndex: 13000,
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))
